import { toTimezone } from 'utils/dateTimeUtils';
import {
  CLEAR_GENERATE_STATE,
  SET_GENERATE_STATE,
  SET_RAW_DATA
} from './actionTypes';

const initialState = {
  records: {},
  groups: [],
  total: {},
  createdOn: null,
  generating: false
};

const rawData = (state = initialState, action) => {
  switch (action.type) {
    case SET_RAW_DATA:
      const { data, data_generated_at } = action.payload.rawData;
      const { raw, report } = data;

      return {
        // All records in groups
        records: raw.data,
        // Group summary data
        groups: report.groupedData.data,
        total: report.totalData,
        createdOn: toTimezone(data_generated_at, true),
        generating: false
      };

    case SET_GENERATE_STATE:
      return {
        ...state,
        generating: true
      };

    case CLEAR_GENERATE_STATE:
      return initialState;

    default:
      return state;
  }
};

export default rawData;



// WEBPACK FOOTER //
// ./src/views/RealTimeReport_Table/flow/reducer.js